import React from 'react';
import { Button } from '@mui/material';
import { FirstAccessIco } from '../../../../../assets/icons_svg';

export const FirstAccessButton = ({ color = "#bdbaba", onClick, disabled }) => {
  return (
    <Button
      disabled={disabled}
      onClick={onClick}
      sx={{
        gap: '4px',
        color: color + ' !important',
        border: `1px solid ${color} !important`,
        backgroundColor: 'transparent',
        padding: '4px 20px !important',
        fontSize: '1rem',
        fontWeight: 700,
        width: '100%',
        textTransform: 'none',
        borderRadius: '4px !important',
        '&:hover': {
          backgroundColor: color,
          borderColor: color,
          color: '#fff !important',
        },
      }}
    >
      Meu{' '}
      <FirstAccessIco fontSize="20px" style={{ color: "#F18932" }} />

      Acesso
    </Button>
  );
}; 
